export default __webpack_public_path__ + "static/media/compactor-icon.a9c98c28.svg";